var _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddLabelButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_445_23",
    "data-name": "Component 445 \\u2013 23",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M7,18a3,3,0,0,1-3-3V7A3,3,0,0,1,7,4,1,1,0,0,0,7,2,5,5,0,0,0,2,7v8a5,5,0,0,0,5,5,1,1,0,0,0,0-2ZM18,7v6a1,1,0,0,0,2,0V7a5,5,0,0,0-5-5,1,1,0,0,0,0,2,3,3,0,0,1,3,3Zm3,11H20V17a1,1,0,0,0-2,0v1H17a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V20h1a1,1,0,0,0,0-2Z",
    transform: "translate(-2 -2)",
    fill: "#434db8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "L",
    transform: "translate(10 14)",
    fill: "#434db8",
    fontSize: 13,
    fontFamily: "Nunito-ExtraBold, Nunito",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "L"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLabelButton);
export default __webpack_public_path__ + "static/media/AddLabelButton.92a5bfa5f68a7cfa05b02db263932ce4.svg";
export { ForwardRef as ReactComponent };